import { render, staticRenderFns } from "./WelcomeSection.vue?vue&type=template&id=28c70a18&scoped=true&"
import script from "./WelcomeSection.vue?vue&type=script&lang=js&"
export * from "./WelcomeSection.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeSection.vue?vue&type=style&index=0&id=28c70a18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c70a18",
  null
  
)

export default component.exports